import { getInsuranceDocMap, zClientInsuranceDocUploads } from '@/general/src/insuranceDoc/shared.js'
import { zDateString, zDateStringOrEmpty } from '@/general/src/other/date.js'
import { z } from 'zod'

const passportCsvSrc = `Название поля в программе,alias,Название поля на фотографии в документе,Подсказка для ИИ,Валидация,Пример заполнения
Фамилия,lastName,,,обязательно,Мошненко
Имя,firstName,,,обязательно,Петр
Отчество,middleName,,может не быть,опционально,Владимирович
Дата рождения,birthDate,,,"обязательно, дата",22.03.1996
Место рождения,birthPlace,,{{city}},обязательно,г. САМАРА
Кем выдан,issuedBy,,,обязательно,ОТДЕЛЕНИЕМ УФМС РОССИИ ПО САМАРСКОЙ ОБЛАСТИ В ОКТЯБРЬСКОМ РАЙОНЕ ГОР. САМАРЫ
Дата выдачи,issuedDate,,Дата выдачи самого паспорта,"обязательно, дата",07.11.2014
Код подразделения,issuedCode,,цифры и дефис,"обязательно, DDD-DDD",630-010
Серия,series,,"Серия паспорта, цифры, всегда 4 символа","обязательно, DD DD",36 14
Номер,number,,"Номер паспорта цифры, оставшиеся цифры после серии, 6 цифр","обязательно, DDDDDD",965321
Регион,residenceRegion,,"{{region}}, может не быть",опционально,ОБЛ САМАРСКАЯ
Пункт/город,residenceCity,,{{city}},обязательно,ГОР. САМАРА
Район,residenceDistrict,,"район области или города, например ""Алексеевский район"", может не быть",опционально,
Улица,residenceStreet,,{{street}},обязательно,УЛ. ЧЕЛЮСКИНЦЕВ
Дом,residenceHouse,,"номер дома, возмажны дополнительные буквенные обозначния",опционально,76
Корпус,residenceBuilding,,"номер корпуса, возможны дополнительные буквенные обозначения",опционально,корп. 1
Квартира,residenceApartment,,"номер квартиры, возможны дополнительные буквенные обозначения",опционально,55
Дата регистрации,residenceRegistrationDate,,Дата регистрации по месту жительства,"обязательно, дата",21 июля 2012 г.
Пол,gender,,"Написано в паспорте, муж. (male) или жен. (female)",обязательно,`

export const zPassport = z.object({
  lastName: z.string().min(1),
  firstName: z.string().min(1),
  middleName: z.string().min(1),
  birthDate: zDateString,
  birthPlace: z.string().min(1),
  issuedBy: z.string().min(1),
  issuedDate: zDateString,
  issuedCode: z.string().min(1),
  series: z.string().min(1),
  number: z.string().min(1),
  residenceRegion: z.string().min(1),
  residenceCity: z.string().min(1),
  residenceDistrict: z.string().optional(),
  residenceStreet: z.string().min(1),
  residenceHouse: z.string().min(1),
  residenceBuilding: z.string(),
  residenceApartment: z.string().min(1),
  residenceRegistrationDate: zDateStringOrEmpty,
  gender: z.enum(['male', 'female']),
})
export type PassportWithoutUploads = z.output<typeof zPassport>
export const zPassportWithUploads = z.object({
  insuranceDocsUploads: zClientInsuranceDocUploads,
  ...zPassport.shape,
})

export const passportFieldsMap = getInsuranceDocMap({
  extra: {
    insuranceDocsUploads: { label: 'Фотографии паспорта (главная старница, прописка)' },
  },
  csv: passportCsvSrc,
  zSchema: zPassportWithUploads,
})
export const getPassportFieldTitle = (field: keyof typeof passportFieldsMap) => passportFieldsMap[field].label
export const getPassportFieldHint = (field: keyof typeof passportFieldsMap) => passportFieldsMap[field].hint

export const passportInitialValues: z.infer<typeof zPassportWithUploads> = {
  insuranceDocsUploads: [],
  lastName: '',
  firstName: '',
  middleName: '',
  birthDate: '',
  birthPlace: '',
  issuedBy: '',
  issuedDate: '',
  issuedCode: '',
  series: '',
  number: '',
  residenceRegion: '',
  residenceCity: '',
  residenceDistrict: '',
  residenceStreet: '',
  residenceHouse: '',
  residenceBuilding: '',
  residenceApartment: '',
  residenceRegistrationDate: '',
  gender: 'male',
}

// export const passportExampleValues: z.infer<typeof zPassportWithUploads> = {
//   insuranceDocsUploads: [],
//   lastName: 'Иванов',
//   firstName: 'Иван',
//   middleName: 'Иванович',
//   birthDate: '02.01.1990',
//   birthPlace: 'Москва',
//   issuedBy: 'Московский ГУВД',
//   issuedDate: '01.01.2020',
//   issuedCode: '1234567890',
//   series: '1234',
//   number: '123456',
//   residenceRegion: 'Москва',
//   residenceCity: 'Москва',
//   residenceDistrict: 'Центральный',
//   residenceStreet: 'Садовая',
//   residenceHouse: '1',
//   residenceBuilding: '',
//   residenceApartment: '1',
//   residenceRegistrationDate: '01.01.2020',
//   gender: 'male',
// }

// export const passportExampleValues: z.infer<typeof zPassportWithUploads> = {
//   insuranceDocsUploads: [],
//   lastName: 'Мошненко',
//   firstName: 'Петр',
//   middleName: 'Владимирович',
//   birthDate: '21.05.1993',
//   birthPlace: 'г. Самара',
//   issuedBy: 'ОТДЕЛЕНИЕМ УФМС РОССИИ ПО САМАРСКОЙ ОБЛАСТИ В ОКТЯБРЬСКОМ РАЙОНЕ ГОР. САМАРЫ',
//   issuedDate: '07.11.2014',
//   issuedCode: '630-010',
//   series: '3614',
//   number: '965321',
//   residenceRegion: 'Самарская область',
//   residenceCity: 'г. Самара',
//   residenceDistrict: '',
//   residenceStreet: 'УЛ. ЧЕЛЮСКИНЦЕВ',
//   residenceHouse: '76',
//   residenceBuilding: '',
//   residenceApartment: '55',
//   residenceRegistrationDate: '21.07.2012',
//   gender: 'male',
// }

export const passportExampleValues: z.infer<typeof zPassportWithUploads> = {
  insuranceDocsUploads: [],
  lastName: 'Лузгин',
  firstName: 'Илья',
  middleName: 'Андреевич',
  birthDate: '15.10.1994',
  birthPlace: 'г. Ульяновск',
  issuedBy: 'ГУ МВД России по Москве',
  issuedDate: '11.11.2014',
  issuedCode: '730-028',
  series: '7314',
  number: '063848',
  residenceRegion: 'Московская область',
  residenceCity: 'г. Люберцы',
  residenceDistrict: '',
  residenceStreet: 'ул. Камова',
  residenceHouse: '5',
  residenceBuilding: 'корп. 1',
  residenceApartment: '40',
  residenceRegistrationDate: '21.12.2021',
  gender: 'male',
}

export const getFioByPassport = (passport: PassportWithoutUploads) => {
  return [passport.lastName, passport.firstName, passport.middleName].filter(Boolean).join(' ') || '—'
}
